// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__IscRn","col":"Table_col__27r8M","fulfillmentStatus":"Table_fulfillmentStatus__2adp0","emailCol":"Table_emailCol__2A-GM"};